import { Component, inject } from '@angular/core';
import { UserService } from '@services/user.service';
import { TranslateService } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { MenuModule } from 'primeng/menu';
import { RouterLink } from '@angular/router';
import { IMenuItemExtended } from '@shared/interfaces/menu.interface';
import { constAppLinks } from '@constants/const.app-links';
import { Ripple } from 'primeng/ripple';
import { EpxSvgIconComponent } from '@shared/components/misc/epx-svg-icon/epx-icon.component';
import { NavigationService } from '@services/navigation.service';
import { finalize } from 'rxjs';
import { Divider } from 'primeng/divider';
import { UserProfileInfoComponent } from '@modules/user/components/user.profile-info/user.profile-info.component';
import { CustomerProfileInfoComponent } from '@modules/customer/components/customer.profile-info/customer.profile.info.component';

@Component({
    selector: 'app-user-profile-menu',
    template: `
        <section class="profile-menu">
            <p-button (onClick)="profileMenu.toggle($event)" icon="pi pi-chevron-down" rounded severity="secondary" variant="text"></p-button>
            <p-menu [model]="menuItems" #profileMenu [popup]="true" appendTo="body">
                <ng-template #start>
                    <section class="profile-menu-start" [style.width.rem]="25">
                        <app-user-profile-info></app-user-profile-info>
                        <p-divider></p-divider>
                        <app-customer-profile-info></app-customer-profile-info>
                    </section>
                    <ng-template #submenuheader let-item>
                        <span class="text-primary font-bold">{{ item.label }}</span>
                    </ng-template>
                    <ng-template #item let-item>
                        @if (item.command && !item.routerLink && !item.url) {
                            <a (click)="(item?.command); $event.preventDefault()" pRipple class="flex items-center p-menu-item-link">
                                @if (item.svgIcon) {
                                    <epx-svg-icon [size]="14" [icon]="item.svgIcon"></epx-svg-icon>
                                }
                                <span>{{ item.label }}</span>
                            </a>
                        }
                        @if (item.routerLink && !item.url) {
                            <a [routerLink]="item.routerLink" pRipple class="flex items-center p-menu-item-link">
                                @if (item.svgIcon) {
                                    <epx-svg-icon [size]="14" [icon]="item.svgIcon"></epx-svg-icon>
                                }
                                <span>{{ item.label }}</span>
                            </a>
                        }
                        @if (item.url && !item.routerLink) {
                            <a [href]="item.url" target="_blank" rel="noopener noreferrer" pRipple class="flex items-center p-menu-item-link">
                                @if (item.svgIcon) {
                                    <epx-svg-icon [size]="14" [icon]="item.svgIcon"></epx-svg-icon>
                                }
                                <span>{{ item.label }}</span>
                            </a>
                        }
                    </ng-template>
                </ng-template>
            </p-menu>
        </section>
    `,
    imports: [ButtonModule, MenuModule, RouterLink, EpxSvgIconComponent, Ripple, Divider, UserProfileInfoComponent, CustomerProfileInfoComponent],
    styleUrls: ['./user-profile-menu.component.scss']
})
export class UserProfileMenuComponent {
    translate = inject(TranslateService);
    userService = inject(UserService);
    navigation = inject(NavigationService);
    menuItems: IMenuItemExtended[] = [];

    constructor() {
        this.menuItems = [
            {
                separator: true
            },
            {
                label: this.translate.instant('MODULE_CUSTOMER.GENERAL.ACCOUNT_DETAILS'),
                routerLink: 'company',
                svgIcon: 'briefcase',
                disabled: false
            },
            {
                separator: true
            },
            {
                label: 'AGB',
                url: constAppLinks.TermsAndConditions,
                svgIcon: 'documents'
            },
            {
                label: 'DSGVO',
                url: constAppLinks.LegalNoticeUrl,
                svgIcon: 'documents'
            },
            {
                separator: true
            },
            {
                label: this.translate.instant('MODULE_AUTH.ACTIONS.SIGN_OUT'),
                svgIcon: 'logout',
                command: () => this.handleLogout()
            }
        ];
    }

    protected handleLogout() {
        this.userService
            .logout()
            .pipe(finalize(() => this.navigation.goToLogin()))
            .subscribe();
    }
}
